import { ChangeDetectionStrategy, Component, computed, forwardRef, input, signal } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { camps } from "../../../../models/models.generated";

@Component({
    selector: "app-sell-camp-coupon",
    templateUrl: "./sell-camp-coupon.component.html",
    styleUrl: "./sell-camp-coupon.component.scss",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SellCampCouponComponent),
            multi: true
        }
    ]
})
export class SellCampCouponComponent implements ControlValueAccessor {
    summary = input.required<camps.PurchaseSummaryModel>();

    couponAppliedSuccessfully = computed(() => this.summary().coupon?.totalValue > 0);
    isExpanded = signal(false);

    couponCode: string = "";
    disabled: boolean = false;

    private onChange: (value: string | null) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string | null): void {
        this.couponCode = value || "";
    }

    registerOnChange(fn: (value: string | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    applyCoupon() {
        if (this.couponCode) {
            this.onChange(this.couponCode);
            this.onTouched();
        }
    }

    removeCoupon() {
        this.couponCode = "";
        this.onChange(null);
        this.onTouched();
    }

    toggleExpand(){
        this.isExpanded.set(!this.isExpanded());
    }
}
